import * as Api from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { getDisplayName } from '../../../../../models/NameUtils';
import { LoadingSpinner } from '../../../../components/LoadingSpinner';
import { AssigneeIcon } from '../../../../components/svgs/icons/AssigneeIcon';
import { BuildingIcon } from '../../../../components/svgs/icons/BuildingIcon';
import { TagIcon } from '../../../../components/svgs/icons/TagIcon';
import { Tag } from '../../../../components/tags/Tag';
import { grayIconFill } from '../../../../styles/colors';
import { baseStyleSheet } from '../../../../styles/styles';
import { styleSheet } from './styles';

interface IContactProps {
	className?: string;
	entity?: Api.IContact | Api.IAccountTag | Api.ICompany;
	highlight: boolean;
	isBusy?: boolean;
	onClick(): void;
	secondaryInfo?: string | JSX.Element;
	styles?: StyleDeclarationValue[];
	type: 'contact' | 'tag' | 'company';
}

export const ContactsAutocompleteResultsItem: React.FC<IContactProps> = props => {
	const { className, styles, entity, highlight, onClick, type, secondaryInfo, isBusy } = props;
	switch (type) {
		case 'company': {
			const company = entity as Api.ICompany;
			return company?.companyName ? (
				<div
					className={`${css(styleSheet.container, highlight && styleSheet.highlight, ...(styles || []))} ${
						className || ''
					}`}
					onClick={onClick}
				>
					<span>
						<BuildingIcon className={css(styleSheet.companiesIcon)} />
					</span>

					<span className={css(styleSheet.name)}>{company.companyName}</span>
				</div>
			) : null;
		}
		case 'contact': {
			const contact = entity as Api.IContact;
			return getDisplayName(contact) ? (
				<div
					className={`${css(styleSheet.container, highlight && styleSheet.highlight, ...(styles || []))} ${
						className || ''
					}`}
					onClick={onClick}
				>
					<div className={css(styleSheet.icon)}>
						<AssigneeIcon style={{ color: grayIconFill }} />
						{isBusy && <LoadingSpinner type='tiny' className={css(baseStyleSheet.absoluteCenter)} />}
					</div>
					<span className={`autocomplete-result-item ${css(styleSheet.name)}`}>{getDisplayName(contact)}</span>
					{secondaryInfo && <span className={css(styleSheet.company)}>{secondaryInfo}</span>}
				</div>
			) : null;
		}
		case 'tag': {
			const tag = entity as Api.IAccountTag;
			return tag?.name ? (
				<div
					onClick={onClick}
					className={`${css(styleSheet.container, highlight && styleSheet.highlight, ...(styles || []))} ${
						className || ''
					}`}
				>
					<span>
						<TagIcon fillColor={grayIconFill} />
					</span>
					<span className={css(styleSheet.name)}>
						<Tag tagValue={tag.name} />
					</span>
				</div>
			) : null;
		}
		default: {
			break;
		}
	}
};
